import {
  collection,
  doc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
} from 'firebase/firestore'
import { db, COLLECTIONS } from '@/lib/firebase'
import type { Banner } from '@/types'

const col = collection(db, COLLECTIONS.banners)

export async function fetchBanners(): Promise<Banner[]> {
  const q = query(col, orderBy('order', 'asc'))
  const snap = await getDocs(q)
  return snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  })) as Banner[]
}

export async function createBanner(
  data: Omit<Banner, 'id' | 'createdAt' | 'updatedAt'>
): Promise<string> {
  const now = new Date().toISOString()
  const ref = await addDoc(col, { ...data, createdAt: now, updatedAt: now })
  return ref.id
}

export async function updateBanner(
  id: string,
  data: Partial<Banner>
): Promise<void> {
  await updateDoc(doc(db, COLLECTIONS.banners, id), {
    ...data,
    updatedAt: new Date().toISOString(),
  })
}

export async function deleteBanner(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTIONS.banners, id))
}
